export enum ACTIONS {
    SET_API_BASE_URL = "APP_CONFIGURATION/SET_API_BASE_URL",
}

interface SetApiBaseUrl {
    type: ACTIONS.SET_API_BASE_URL;
    payload: string;
}

export type ActionType = SetApiBaseUrl;
